import {combineReducers} from 'redux'
import {dates} from '../../../../commons/reducers/dates'
import {environment} from '../../../../commons/reducers/environment'
import {focusHandler} from '../../../../commons/reducers/focus-handler'
import {installedApps} from '../../../../commons/reducers/installed-apps'
import {multilingual} from '../../../../commons/reducers/multilingual'
import {toastHandler} from '../../../../commons/reducers/toast-handler'
import {MembersPageState} from '../types/state'
import {demoEvents} from './demo-events'
import {eventsReducer as events} from './events'
import {expandedEvents} from './expanded-events'
import {loading} from './loading'
import {navigation} from './navigation'
import {tab} from './tab'
import {tickets} from './tickets'
import {user} from './user'
import {viewReducer} from './view'

export default combineReducers<MembersPageState>({
  user,
  environment,
  events,
  expandedEvents,
  tab,
  loading,
  navigation,
  demoEvents,
  view: viewReducer,
  multilingual,
  tickets,
  dates,
  focusHandler,
  toastHandler,
  installedApps,
})
